export const openNoteHelper = ({ context, note }) => {
  // If same note is already selected, return current state unchanged
  if (note?.note_id === context?.selectedNote?.note_id) {
    return {
      selectedNote: context.selectedNote,
      selectedNoteId: context.selectedNoteId,
    };
  }

  return {
    selectedNote: note,
    selectedNoteId: note.note_id,
  };
};
